<!-- 考试结果 -->
<template>
  <div class="frame">
    <el-backtop
      title="回到顶部"
      :visibility-height="400"
      :right="70"
      :bottom="53"
    ></el-backtop>
    <div class="top">
      <div class="back-box">
        <div class="back" @click="navBack">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="title">{{ resultObj.paperTitle }}</div>
      <div class="score-info">
        <p>
          总分：<span class="num">{{ resultObj.totalScore }}</span
          >分
        </p>
        <p>
          合格分数线：<span class="num">{{ resultObj.passingScore }}</span
          >分
        </p>
        <p>
          答题耗时：
          <span v-if="spendMin != 0">
            <span class="num">{{ spendMin }}</span>
            分钟
          </span>
          <span v-if="spendSecond != 0">
            <span class="num">{{ spendSecond }}</span
            >秒
          </span>
        </p>
      </div>
      <div class="score">
        得分：<span>{{ resultObj.resultScore }}</span
        >分
      </div>
      <div class="tip nopass" v-if="resultObj.examinationStatus == 0">
        很遗憾您未通过本次考试!
      </div>
      <div class="tip pass" v-else>恭喜您通过本次考试!</div>
    </div>
    <div class="wrap">
      <div class="left">
        <div class="result-box">
          <div class="tab">成绩单</div>
          <div class="table">
            <div class="tr th">
              <div class="td">题型</div>
              <div class="td">总题数/答对题</div>
              <div class="td">总分/得分</div>
            </div>
            <div class="tr">
              <div class="td">单选题</div>
              <div class="td">
                {{ sigleAllList.length }} / {{ sigleCurrectList.length }}
              </div>
              <div class="td">{{ sigleScore }} / {{ sigleCurrectScore }}</div>
            </div>
            <div class="tr">
              <div class="td">多选题</div>
              <div class="td">
                {{ mutipleAllList.length }} / {{ mutipleCurrectList.length }}
              </div>
              <div class="td">
                {{ mutipleScore }} / {{ mutipleCurrectScore }}
              </div>
            </div>
            <div class="tr">
              <div class="td">判断题</div>
              <div class="td">
                {{ judgeAllList.length }} / {{ judgeCurrectList.length }}
              </div>
              <div class="td">{{ judgeScore }} / {{ judgeCurrectScore }}</div>
            </div>
            <div class="tr">
              <div class="td w100">
                本次考试共
                <span>{{
                  sigleAllList.length +
                  mutipleAllList.length +
                  judgeAllList.length
                }}</span>
                道题，总分
                <span>{{ resultObj.totalScore }}</span>
                分，您做对
                <span>{{
                  sigleCurrectList.length +
                  mutipleAllList.length +
                  judgeCurrectList.length
                }}</span>
                道题，得到
                <span>{{ resultObj.resultScore }}</span>
                分
              </div>
            </div>
          </div>
        </div>
        <div class="select-list">
          <div
            :class="['select-item', item.resultFlag == 0 ? 'error' : 'success']"
            v-for="item in questionList"
            :key="item.id"
            @click="switchToQuestion(item.order)"
          ></div>
        </div>
      </div>
      <div class="right">
        <div class="questiones">
          <div class="question" v-for="item in questionList" :key="item.label">
            <div class="title">
              <el-tag type="success" size="small" v-if="item.questionType == 0"
                >单选题</el-tag
              >
              <el-tag size="small" v-else-if="item.questionType == 1"
                >多选题</el-tag
              >
              <el-tag type="warning" size="small" v-else>判断题</el-tag>
              <span class="name">
                {{ item.order }}、{{ item.questionTitle }}
              </span>
              <!-- <span class="choice">{{ item.questionAnswer }}</span> -->
            </div>
            <div class="content" v-if="item.questionType != 1">
              <el-radio-group class="group" :value="item.userChooseResult">
                <div
                  class="option"
                  v-for="option in item.questionChoose"
                  :key="option.label"
                >
                  <el-radio :label="option.value">{{ option.label }}</el-radio>
                </div>
              </el-radio-group>
              <div class="choice-answer">
                <p :class="[item.resultFlag == 0 ? 'error' : 'success']">
                  <span>{{ item.resultFlag == 0 ? "错误" : "正确" }}</span>
                </p>
                <p :class="[item.resultFlag == 0 ? 'error' : 'success']">
                  你的选择：<span>{{ item.userChooseResult }}</span>
                </p>
                <p class="currect">
                  正确答案：<span>{{ item.questionAnswer }}</span>
                </p>
              </div>
              <div class="analysis">答案解析：{{ item.questionAnalyze }}</div>
            </div>
            <div class="content" v-else>
              <el-checkbox-group class="group" :value="item.userChooseResult">
                <div
                  class="option"
                  v-for="option in item.questionChoose"
                  :key="option.label"
                >
                  <el-checkbox :label="option.value">{{
                    option.label
                  }}</el-checkbox>
                </div>
              </el-checkbox-group>
              <div class="choice-answer">
                <p :class="[item.resultFlag == 0 ? 'error' : 'success']">
                  <span>{{ item.resultFlag == 0 ? "错误" : "正确" }}</span>
                </p>
                <p :class="[item.resultFlag == 0 ? 'error' : 'success']">
                  你的选择：<span>{{ item.userChooseResult.join(",") }}</span>
                </p>
                <p class="currect">
                  正确答案：<span>{{ item.questionAnswer }}</span>
                </p>
              </div>
              <div class="analysis">答案解析：{{ item.questionAnalyze }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      paper: {},
      resultObj: {}, // 考试结果对象
      questionList: [], // 考题
      dealine: 0, // 倒计时结束时间
      sigleAllList: [], // 单选题
      sigleCurrectList: [], // 正确的单选题
      sigleScore: 0, // 单选题总分
      sigleCurrectScore: 0, // 单选题正确得分
      mutipleAllList: [], // 多选题
      mutipleCurrectList: [], // 正确的多选题
      mutipleScore: 0, // 多选题总分
      mutipleCurrectScore: 0, // 单选题正确得分
      judgeAllList: [], // 判断题
      judgeCurrectList: [], // 正确的判断题
      judgeScore: 0, // 判断题总分
      judgeCurrectScore: 0, // 单选题正确得分
      loading: false,
      spendMin: 0, // 花了多少分钟
      spendSecond: 0, // 花了多少秒
    };
  },
  created() {
    this.$api.getTestResult({ resultId: this.$route.params.id }).then((res) => {
      this.resultObj = res.data;
      // 耗时处理
      this.resultObj.spendTime =
        new Date(res.data.examinationEndTime).getTime() -
        new Date(res.data.examinationStartTime).getTime();
      this.spendMin = new Date(this.resultObj.spendTime).getMinutes();
      this.spendSecond = new Date(this.resultObj.spendTime).getSeconds();
      // 题目处理
      this.questionList = res.data.examinationQuestionResults.map(
        (ele, idx) => {
          ele.order = idx + 1;
          ele.questionChoose = JSON.parse(ele.questionChoose);
          if (ele.questionType == 1) {
            // 多选题答案特殊处理
            ele.userChooseResult = ele.userChooseResult.split(",");
          }
          return ele;
        }
      );
      this.handleScore();
    });
  },
  methods: {
    navBack() {
      this.$router.back();
    },
    // 题目得分处理
    handleScore() {
      // 单选题数据得分情况处理
      this.sigleAllList = this.questionList.filter(
        (ele) => ele.questionType == 0
      );
      this.sigleCurrectList = this.sigleAllList.filter(
        (ele) => ele.resultFlag == 1
      );
      this.sigleScore = this.sigleAllList.reduce(
        (a, b) => a + b.questionScore,
        0
      );
      this.sigleCurrectScore = this.sigleCurrectList.reduce(
        (a, b) => a + b.score,
        0
      );
      // 多选题数据得分情况处理
      this.mutipleAllList = this.questionList.filter(
        (ele) => ele.questionType == 1
      );
      this.mutipleCurrectList = this.mutipleAllList.filter(
        (ele) => ele.resultFlag == 1
      );
      this.mutipleScore = this.mutipleAllList.reduce(
        (a, b) => a + b.questionScore,
        0
      );
      this.mutipleCurrectScore = this.mutipleCurrectList.reduce(
        (a, b) => a + b.score,
        0
      );
      // 判断题数据得分情况处理
      this.judgeAllList = this.questionList.filter(
        (ele) => ele.questionType == 2
      );
      this.judgeCurrectList = this.judgeAllList.filter(
        (ele) => ele.resultFlag == 1
      );
      this.judgeScore = this.judgeAllList.reduce(
        (a, b) => a + b.questionScore,
        0
      );
      this.judgeCurrectScore = this.judgeCurrectList.reduce(
        (a, b) => a + b.score,
        0
      );
    },
    // 跳转到对应题目
    switchToQuestion(order) {
      let doms = document.getElementsByClassName("question");
      window.scrollTo({ top: doms[order - 1].offsetTop });
    },
  },
};
</script>

<style lang="scss" scoped>
.option ::v-deep {
  .el-radio__input.is-checked + .el-radio__label,
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #409eff;
  }
  .el-radio__input.is-checked .el-radio__inner,
  .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #409eff;
    background: #409eff;
  }
}
.el-tag {
  color: #409eff;
  background-color: #ecf5ff;
  border: 1px solid #d9ecff;
}
.frame {
  background-color: #f9f9f9;
}
.top {
  width: 100%;
  height: 250px;
  background-color: #409eff;
  clip-path: polygon(
    0 0,
    100% 0,
    100% calc(100% - 30px),
    calc(50% + 370px) 100%,
    47% calc(100% - 27px),
    calc(50% - 370px) 100%,
    0 calc(100% - 30px)
  );
  color: #fff;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  .back-box {
    width: 1200px;
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;

    .back {
      color: #fff;
      font-size: 20px;
      cursor: pointer;

      &:hover {
        color: $theme;
      }
    }
  }

  .title {
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .desc {
    font-size: 18px;
  }
  .score-info {
    font-size: 14px;
    color: #fff;
    display: flex;

    p {
      & + p {
        margin-left: 20px;
      }
      .num {
        color: $theme;
        font-weight: bold;
      }
    }
  }
  .tip {
    font-weight: bold;
    margin-top: 10px;
  }
  .nopass {
    color: $theme;
  }
  .pass {
    color: #67c23a;
  }
  .score {
    color: $theme;
    font-size: 20px;
    margin-top: 10px;

    span {
      font-size: 36px;
    }
  }
}

.wrap {
  display: flex;
  align-items: flex-start;
  width: 1200px;
  margin: 20px auto 0;
  padding-bottom: 40px;

  .left {
    width: 380px;
    margin-right: 20px;
    position: sticky;
    top: 20px;

    .title {
      font-size: 20px;
    }

    .result-box {
      background-color: #fff;
      padding: 20px;
      border-radius: 5px;
      box-shadow: 0 0 5px #eee;

      .tab {
        border-bottom: 1px solid #999;
        padding: 0 8px 8px;
        font-size: 14px;
      }

      .table {
        border-top: 1px solid #ddd;
        border-left: 1px solid #ddd;
        margin-top: 10px;
        font-size: 14px;

        .tr {
          display: flex;

          .td {
            width: 33%;
            padding: 5px;
            border-right: 1px solid #ddd;
            border-bottom: 1px solid #ddd;
          }
          .w100 {
            width: 100%;

            span {
              color: #e13f38;
              font-weight: bold;
            }
          }
        }
        .th {
          background-color: #d9edf7;
          font-weight: bold;
        }
      }
    }

    .select-list {
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;
      background-color: #fff;
      padding: 20px;
      border-radius: 5px;
      box-shadow: 0 0 5px #eee;

      .select-item {
        width: 20px;
        height: 20px;
        border-radius: 5px;
        border: 1px solid #999;
        margin: 0 5px 10px;
        cursor: pointer;
      }
      .select {
        background-color: #409eff;
        border-color: #409eff;
      }
      .success {
        background-color: #67c23a;
        border-color: #67c23a;
      }
      .error {
        background-color: #e13f38;
        border-color: #e13f38;
      }
    }
    .menus {
      margin-top: 20px;
      display: flex;
      justify-content: center;

      .btn {
        width: fit-content;
        background-color: #409eff;
        color: #fff;
        font-weight: 500;
        padding: 8px 20px;
        font-size: 14px;
        border-radius: 4px;
        user-select: none;

        &:hover {
          cursor: pointer;
          background-color: #66b1ff;
        }
        & + .btn {
          margin-left: 10px;
        }

        i {
          margin-right: 5px;
          font-size: 16px;
        }
      }
    }
  }
  .right {
    width: 800px;
    background-color: #fff;
    border-radius: 5px;
    padding: 10px;
    box-shadow: 0 0 5px #eee;

    .questiones {
      border: 1px solid #dedede;

      .question {
        padding: 10px;

        &:last-child {
          .content {
            border-bottom: none;
          }
        }

        .title {
          .name {
            margin-left: 10px;
            vertical-align: middle;
          }
          .choice {
            margin-left: 10px;
            color: #409eff;
            vertical-align: middle;
          }
        }
        .content {
          padding: 30px 10px 20px;
          border-bottom: 1px solid #dedede;

          .group {
            display: flex;
            flex-wrap: wrap;

            .option {
              min-width: 50%;
              line-height: 28px;
              margin-bottom: 10px;
            }
          }

          .choice-answer {
            display: flex;
            font-size: 14px;

            p {
              margin-right: 15px;
            }
            .currect span {
              color: #67c23a;
            }
            .success span {
              color: #67c23a;
            }
            .error span {
              color: #e13f38;
            }
          }
          .analysis {
            font-size: 14px;
            white-space: pre-wrap;
            margin-top: 10px;
            color: #666;
            line-height: 1.4;
          }
        }
      }
    }
  }
}
</style>
